(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amy-devotional-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const dialog = document.querySelector('[data-amy-devotional-modal]');
      if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.ready === 'true') return;
      dialog.dataset.ready = 'true';

      const storageKey = 'amy-devotional-signup-submitted';
      const closeButton = dialog.querySelector('[data-amy-devotional-close]');
      const form = dialog.querySelector('.email-signup__form');
      const successMessage = dialog.querySelector('.email-signup__message--success');
      const download = dialog.querySelector('[data-amy-devotional-download]');
      let lastTrigger = null;

      const openDialog = (trigger) => {
        if (trigger) lastTrigger = trigger;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('amy-devotional-modal-open');
        window.requestAnimationFrame(() => dialog.querySelector('input[type="email"]')?.focus());
      };

      const closeDialog = () => {
        if (dialog.open) dialog.close();
      };

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href="#free-devotional"]');
        if (!trigger) return;
        event.preventDefault();
        openDialog(trigger);
      });

      closeButton?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('amy-devotional-modal-open');
        lastTrigger?.focus();
      });

      form?.addEventListener('submit', () => {
        window.sessionStorage.setItem(storageKey, 'true');
      });

      const submittedHere = window.sessionStorage.getItem(storageKey) === 'true';
      if (successMessage && download) download.hidden = false;
      if (submittedHere || window.location.hash === '#free-devotional') {
        window.sessionStorage.removeItem(storageKey);
        openDialog(null);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
